/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ListadoAlertasModelDto } from '../../models/listado-alertas-model-dto';

export interface DoctorAlertaControllerObtenerAlertas$Params {
  limit?: number;
  page?: number;
  tipoAlerta?: 'INTERACCION_FARMACO' | 'INCIDENCIA' | 'VALOR_ANALITICA_FUERA_RANGO' | 'AUSENCIA_CITA' | 'CANCELACION_CITA' | 'ENCUESTA' | 'EFECTO_SECUNDARIO_REACCION';
  prioridad?: 'ALTA' | 'MEDIA' | 'BAJA';
  nombreApellidos?: string;
  leido?: boolean;
  fechaDesde?: string;
  fechaHasta?: string;
  uuidPrograma?: string;
}

export function doctorAlertaControllerObtenerAlertas(http: HttpClient, rootUrl: string, params?: DoctorAlertaControllerObtenerAlertas$Params, context?: HttpContext): Observable<StrictHttpResponse<ListadoAlertasModelDto>> {
  const rb = new RequestBuilder(rootUrl, doctorAlertaControllerObtenerAlertas.PATH, 'get');
  if (params) {
    rb.query('limit', params.limit, {});
    rb.query('page', params.page, {});
    rb.query('tipoAlerta', params.tipoAlerta, {});
    rb.query('prioridad', params.prioridad, {});
    rb.query('nombreApellidos', params.nombreApellidos, {});
    rb.query('leido', params.leido, {});
    rb.query('fechaDesde', params.fechaDesde, {});
    rb.query('fechaHasta', params.fechaHasta, {});
    rb.query('uuidPrograma', params.uuidPrograma, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ListadoAlertasModelDto>;
    })
  );
}

doctorAlertaControllerObtenerAlertas.PATH = '/api/doctor-alertas/obtener-alertas';
